import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import useApiV2, {
  CINCO_MINUTOS,
  repetirSoErroDeServidor,
} from "../utils/useApiV2";

export default function useAttentionV2({
  branchId,
  start,
  end,
  groupBy = "none",
  filtros = {},
  enabled = true,
}) {
  const { getAttentionMetrics } = useApiV2();
  const { user } = useAuth();

  return useQuery({
    queryKey: [
      "attentionV2",
      user?.user_id ?? null,
      branchId,
      start,
      end,
      groupBy,
      filtros,
    ],
    queryFn: () =>
      getAttentionMetrics({
        branch_id: branchId,
        start,
        end,
        group_by: groupBy,
        ...filtros,
      }),
    enabled: Boolean(enabled && branchId && start && end),
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  });
}
